import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import BetaToggleInput from 'components/users/beta_program/beta_toggle_input';
import CheckCircle from 'components/svgs/check_circle';
import { updateBetaProgramOptionsForUser } from 'components/users/api';

class BetaProgramForm extends React.Component {
  static propTypes = {
    options: PropTypes.shape({
      crmBetaProgram: PropTypes.bool,
      crmFeedbackProgram: PropTypes.bool,
      marketingBetaProgram: PropTypes.bool,
      marketingFeedbackProgram: PropTypes.bool,
      transactionManagementBetaProgram: PropTypes.bool,
      transactionManagementFeedbackProgram: PropTypes.bool,
    }),
    userId: PropTypes.number,
  }

  constructor(props) {
    super(props);
    const {
      crmBetaProgram,
      crmFeedbackProgram,
      marketingBetaProgram,
      marketingFeedbackProgram,
      transactionManagementBetaProgram,
      transactionManagementFeedbackProgram
    } = props.options;

    this.state = {
      marketingBetaProgram,
      transactionManagementBetaProgram,
      crmBetaProgram,
      marketingFeedbackProgram,
      transactionManagementFeedbackProgram,
      crmFeedbackProgram,
      saved: false
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleUnsubscribeAll = this.handleUnsubscribeAll.bind(this);
  }

  handleChange(key, value) {
    this.setState({ [key]: value });
  }

  handleUnsubscribeAll() {
    const newOptions = {
      marketingBetaProgram: false,
      transactionManagementBetaProgram: false,
      crmBetaProgram: false,
      marketingFeedbackProgram: false,
      transactionManagementFeedbackProgram: false,
      crmFeedbackProgram: false
    };
    this.setState(newOptions);

    this.saveBetaOptions(newOptions);
  }

  handleSave() {
    this.saveBetaOptions(this.state);
  }

  saveBetaOptions(newOptions) {
    updateBetaProgramOptionsForUser(this.props.userId, newOptions).then(() => {
      this.setState({ saved: true });

      setTimeout(() => {
        location.reload();
      }, 1000);
    });
  }

  allUnsubscribed() {
    const { saved, ...options } = this.state;
    const iterable = saved ? options : this.props.options;

    return Object.values(iterable).some(item => !!item);
  }

  render() {
    return (
      <Fragment>
        <div className="panel panel-default beta-program-panel">
          <div className="panel-body">
            <p>
              <b>Our Beta Program</b> will give you early access to new features that we're working on to test out and
              provide feedback early. Us learning how you use these new features or workflows will help influence what's
              released to everyone at the time of launch.
            </p>
            <BetaToggleInput
              checked={this.state.marketingBetaProgram}
              label="Marketing"
              onChange={e => this.handleChange('marketingBetaProgram', e.target.checked)}
            />
            <BetaToggleInput
              checked={this.state.transactionManagementBetaProgram}
              label="Transaction Management"
              onChange={e => this.handleChange('transactionManagementBetaProgram', e.target.checked)}
            />
            <BetaToggleInput
              checked={this.state.crmBetaProgram}
              label="CRM"
              onChange={e => this.handleChange('crmBetaProgram', e.target.checked)}
            />
          </div>
        </div>

        <div className="panel panel-default feedback-program-panel">
          <div className="panel-body">
            <p>
              <b>Our Feedback Program</b> will give you an opportunity to chat directly with our product managers to
              help shape the future of Buildout. This could be to help identify key problems or workflows you think
              are missing or even providing your feedback on some market changes we're seeing. All feedback is good
              feedback.
            </p>
            <BetaToggleInput
              checked={this.state.marketingFeedbackProgram}
              label="Marketing"
              onChange={e => this.handleChange('marketingFeedbackProgram', e.target.checked)}
            />
            <BetaToggleInput
              checked={this.state.transactionManagementFeedbackProgram}
              label="Transaction Management"
              onChange={e => this.handleChange('transactionManagementFeedbackProgram', e.target.checked)}
            />
            <BetaToggleInput
              checked={this.state.crmFeedbackProgram}
              label="CRM"
              onChange={e => this.handleChange('crmFeedbackProgram', e.target.checked)}
            />
          </div>
        </div>

        <p className="text-italic">NOTE: these features are not guaranteed</p>

        {this.state.saved && (
          <div className="d-flex align-items-center mb-3">
            <CheckCircle animate className="small mr-3" />
            The preferences were successfully saved. Please wait for reloading.
          </div>
        )}

        <div className="d-flex align-items-center">
          <button className="btn btn-save" disabled={this.state.saved} onClick={this.handleSave}>
            Save Changes
          </button>
          {this.allUnsubscribed() && (
            <button
              className="btn button--text red ml-3"
              disabled={this.state.saved}
              onClick={this.handleUnsubscribeAll}
            >
              Unsubscribe from all
            </button>
          )}
        </div>
      </Fragment>
    );
  }
}

export default BetaProgramForm;
